
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"46","height":"46","viewBox":"0 0 46 46"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 135577","transform":"translate(.386)"}},[_c('rect',{attrs:{"data-name":"Rectangle 111408","width":"46","height":"46","rx":"12","transform":"translate(-.386)","fill":"#2363ce","opacity":".1"}}),_c('g',{attrs:{"data-name":"Group 135573"}},[_c('g',{attrs:{"fill":"none","stroke":"#2363ce","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","data-name":"vuesax/twotone/building"}},[_c('path',{attrs:{"d":"M23.197 35.667h-9.823a2.445 2.445 0 01-2.462-2.415V15.938c0-3.056 2.275-4.445 5.063-3.08l5.18 2.543a3.971 3.971 0 012.042 3.243z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M34.245 27.57v4.41c0 2.52-1.167 3.687-3.687 3.687h-7.361v-13.51l.548.117 5.252 1.178 2.368.525a3.205 3.205 0 012.87 3.372 1.34 1.34 0 01.01.221z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M15.03 20.5h4.048M15.03 25.167h4.048","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M28.995 23.452v3.757a2.625 2.625 0 11-5.25 0v-4.935z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M34.233 27.352a2.621 2.621 0 01-5.238-.143v-3.757l2.368.525a3.205 3.205 0 012.87 3.375z"}})])])])])
          )
        }
      }
    